/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Review_Con5Inputs */

const en_fc_home_review_con5 = /** @type {(inputs: Fc_Home_Review_Con5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Less tested on Windows and Linux than on macOS.`)
};

/**
* | output |
* | --- |
* | "Less tested on Windows and Linux than on macOS." |
*
* @param {Fc_Home_Review_Con5Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_review_con5 = /** @type {((inputs?: Fc_Home_Review_Con5Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Review_Con5Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_review_con5(inputs)
});
export { fc_home_review_con5 as "fc.home.review.con5" }